import {
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  IconButton,
  ListItem /* TextField */,
  TextField,
  Tooltip,
} from "@mui/material";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import CoreTabBar from "../../../../app/core/components/CoreTabBar/CoreTabBar";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { toast } from "react-toastify";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
//import FlagCircleRoundedIcon from "@mui/icons-material/FlagCircleRounded";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import {
  useDeleteCategoryMutation,
  useEditCategoryMutation,
  useGetCategoryKeywordsQuery,
  useGetCategoryQueriesQuery,
  useSetKeywordsMutation,
  useSetQueriesMutation,
} from "../../../api/admin/categoriesApi";
import { SkeletonsHorizontalLine } from "../../../common/LoadingStuff/Skeletons/SkeletonsHorizontalLine";
import CoreDialog from "../../../../app/core/components/CoreDialog/CoreDialog";
import AbcRoundedIcon from "@mui/icons-material/AbcRounded";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import PinOutlinedIcon from "@mui/icons-material/PinOutlined";
//import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import CoreSelectObjArr from "../../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { useSelector } from "react-redux";
import CoreMaxCharacter from "../../../../app/core/components/CoreMaxCharacter/CoreMaxCharacter";

const header = (tab) => {
  switch (tab) {
    case "queries":
      return (
        <div className="bg-zinc-50 flex p-2 px-2 gap-4">
          <p className="w-2/6">{t("Query")}</p>
          <p className="text-center w-2/6">{t("Description")}</p>
          <p className="text-center w-1/6">{t("DataType")}</p>
          <p className="text-center w-1/6">{t("Actions")}</p>
        </div>
      );
    default:
      return (
        <div className="bg-zinc-50 flex p-2 px-2 gap-4">
          <p className="w-2/3">{t("Keyword")}</p>
          <p className="text-center w-1/6">{t("Weight")}</p>
          <p className="text-center w-1/6">{t("Actions")}</p>
        </div>
      );
  }
};

const dataTypeElements = () => [
  {
    label: (
      <div className="flex gap-2 items-center">
        <AbcRoundedIcon style={{ color: "grey" }} />
        {t("Text")}
      </div>
    ),
    value: "String",
  },
  {
    label: (
      <div className="flex gap-2 items-center">
        <PinOutlinedIcon style={{ color: "grey" }} />
        {t("Number")}
      </div>
    ),
    value: "Number",
  },

  {
    label: (
      <div className="flex gap-2 items-center">
        <AccessTimeRoundedIcon style={{ color: "grey" }} />
        {t("Date")}
      </div>
    ),
    value: "Date",
  },
];

const CategoryDetail = ({
  macroCategories,
  selectedCategory,
  setSelectedCategory,
  isCategoryChanged,
  setIsCategoryChanged,
}) => {
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const TABS_CATEGORY_PROPERTIES = [
    {
      label: t("Keywords"),
      tab: "keywords",
    },
    {
      label: t("Queries"),
      tab: "queries",
    },
  ];
  const [selectedTab, setSelectedTab] = useState("keywords");
  const [categoryToChange, setCategoryToChange] = useState({
    keywords: [],
    queries: [],
  });
  const [newKeywordOrQuery, setNewKeywordOrQuery] = useState("");
  const [editNameCategoryMode, setEditNameCategoryMode] = useState({
    active: false,
    newName: selectedCategory?.name,
  });
  const [selectedMacroCategoryForEdit, setSelectedMacroCategoryForEdit] =
    useState(selectedCategory?.mainCategoryId);
  const [showDeleteCategoryDialog, setShowDeleteCategoryDialog] =
    useState(false);

  const maxCharacter = 1000;

  const {
    data: keywordsData,
    isLoading: isKeywordsDataLoading,
    isFetching: isKeywordsDataFetching,
  } = useGetCategoryKeywordsQuery(selectedCategory?.id, {
    skip: !selectedCategory,
  });
  const {
    data: queriesData,
    isLoading: isQueriesDataLoading,
    isFetching: isQueriesDataFetching,
  } = useGetCategoryQueriesQuery(selectedCategory?.id, {
    skip: !selectedCategory,
  });
  const isDataLoading =
    isKeywordsDataLoading ||
    isKeywordsDataFetching ||
    isQueriesDataLoading ||
    isQueriesDataFetching;
  const [setKeywords, { isLoading: isSettingKeywords }] =
    useSetKeywordsMutation();
  const [setQueries, { isLoading: isSettingQueries }] = useSetQueriesMutation();
  const [editCategory, { isLoading: isEditingCategoryName }] =
    useEditCategoryMutation();
  const [deleteCategory, { isLoading: isRemovingCategory }] =
    useDeleteCategoryMutation();

  useEffect(() => {
    if (keywordsData && keywordsData.Data)
      setCategoryToChange((prev) => ({
        ...prev,
        keywords: keywordsData.Data.items,
      }));
  }, [keywordsData]);

  useEffect(() => {
    if (queriesData && queriesData.Data)
      setCategoryToChange((prev) => ({
        ...prev,
        queries: queriesData.Data.items.map((e) =>
          //Rimappo le query e aggiungo il boolean "freeQuery" a true se avevo salvato una query libera in precedenza in quanto l'informazione non viene salvata a db
          e.query === "Campo libero" ? { ...e, freeQuery: true } : e
        ),
      }));
  }, [queriesData]);

  useEffect(() => {
    handleEditCategoryName(selectedCategory?.name);
    setEditNameCategoryMode((prev) => ({ ...prev, active: false }));
    setSelectedMacroCategoryForEdit(selectedCategory?.mainCategoryId);
  }, [
    selectedCategory,
    selectedCategory?.name,
    selectedCategory?.mainCategoryId,
  ]);

  const handleAddNewCategoryOrQuery = () => {
    const categoriesOrQueriesArray = [...categoryToChange[selectedTab]];
    const newItem =
      selectedTab === "keywords"
        ? { keyword: newKeywordOrQuery, weight: 0 }
        : { query: newKeywordOrQuery, description: "" };
    categoriesOrQueriesArray.push(newItem);
    setCategoryToChange((prev) => ({
      ...prev,
      [selectedTab]: categoriesOrQueriesArray,
    }));
    setNewKeywordOrQuery("");
    setIsCategoryChanged(true);
  };

  const handleChangeInput = (e, idx) => {
    let { value, name } = e.target;
    if (name === "freeQuery") {
      value = e.target.checked;
      setCategoryToChange((prevData) => ({
        //se seleziono freeQuery aggiungo "Campo libero" come query altrimenti str vuota
        ...prevData,
        [selectedTab]: prevData[selectedTab].map((item, index) =>
          index === idx
            ? {
                ...item,
                query: value ? "Campo libero" : "",
                fieldType: value ? "String" : "",
              }
            : item
        ),
      }));
    }
    setCategoryToChange((prevData) => ({
      ...prevData,
      [selectedTab]: prevData[selectedTab].map((item, index) =>
        index === idx ? { ...item, [name]: value } : item
      ),
    }));
    setIsCategoryChanged(true);
  };
  const handleDeleteItem = (idx) => {
    const newKeywordsOrCategoriesArray = [...categoryToChange[selectedTab]];
    newKeywordsOrCategoriesArray.splice(idx, 1);
    setCategoryToChange((prevData) => ({
      ...prevData,
      [selectedTab]: [...newKeywordsOrCategoriesArray],
    }));
    setIsCategoryChanged(true);
  };

  const handleSave = async () => {
    const id = toast.loading(t("Saving..."), {
      type: "info",
    });
    const keywordsData = categoryToChange.keywords;
    const queriesData = categoryToChange.queries;
    try {
      await setKeywords({
        categoryId: selectedCategory.id,
        keywords: keywordsData,
      });
      const queryResponse = await setQueries({
        categoryId: selectedCategory.id,
        queries: queriesData,
      });

      if (queryResponse?.error?.data) {
        toast.update(id, {
          render: t("CategoryNotUpdated"),
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
        return;
      }
      toast.update(id, {
        render: t("CategoryUpdated"),
        type: "success",
        autoClose: 1500,
        isLoading: false,
      });
      setSelectedTab("keywords"); //dopo la chiamata risetto la tab keywords per evitare un bug di interfaccia
      setIsCategoryChanged(false);
      setSelectedCategory(undefined);
    } catch (error) {
      toast.update(id, {
        render: t("CategoryNotUpdated"),
        type: "error",
        autoClose: 1500,
        isLoading: false,
      });
    }
  };

  const handleEditCategoryNameMode = () => {
    setEditNameCategoryMode((prev) => ({ ...prev, active: !prev.active }));
  };
  const handleEditCategoryName = (newName) => {
    setEditNameCategoryMode((prev) => ({ ...prev, newName: newName }));
  };

  const handleEditCategoryNameApi = async () => {
    const data = {
      categoryId: selectedCategory.id,
      body: {
        name: editNameCategoryMode.newName,
        description: "",
        mainCategoryId: selectedMacroCategoryForEdit,
      },
    };
    await editCategory(data);
    handleEditCategoryNameMode();
  };

  const handleDeleteCategory = async () => {
    const id = toast.loading(t("Deleting..."), {
      type: "info",
    });
    try {
      await deleteCategory(selectedCategory.id);
      toast.update(id, {
        render: t("CategoryDeleted"),
        type: "success",
        autoClose: 1500,
        isLoading: false,
      });
      setSelectedTab("keywords"); //dopo la chiamata risetto la tab keywords per evitare un bug di interfaccia
      setIsCategoryChanged(false);
      setSelectedCategory(undefined);
      setShowDeleteCategoryDialog(false);
    } catch (error) {
      toast.update(id, {
        render: t("CategoryNotDeleted"),
        type: "error",
        autoClose: 1500,
        isLoading: false,
      });
    }
  };

  if (!selectedCategory)
    return (
      <div
        style={{ border: "1px dashed #0000001f", height: "75vh" }}
        className="w-full xl:w-1/2 h-full flex p-4 rounded-md shadow-md text-gray justify-center items-center"
      >
        <h4>{t("SelectCategory")}</h4>
      </div>
    );
  return (
    <div
      style={{
        border: "1px solid #0000001f",
        height: "75vh",
      }}
      className="w-full xl:w-1/2 h-full p-2 rounded-md shadow-md"
    >
      <div className="w-full flex justify-between px-2">
        <div className="w-full flex items-center gap-4">
          {editNameCategoryMode.active ? (
            <>
              <TextField
                label={t("CategoryName")}
                value={editNameCategoryMode.newName}
                onChange={(e) => handleEditCategoryName(e.target.value)}
                className="my-1 w-72"
              />
              <CoreSelectObjArr
                label={t("MacroCategory")}
                items={macroCategories}
                className="w-72 mt-1 flex items-center"
                size="lg"
                value={selectedMacroCategoryForEdit}
                onChange={(e) =>
                  setSelectedMacroCategoryForEdit(e.target.value)
                }
              />
            </>
          ) : (
            <Tooltip title={editNameCategoryMode.newName}>
              <h3>
                {editNameCategoryMode.newName?.length > 19
                  ? editNameCategoryMode.newName?.substring(0, 19) + "..."
                  : editNameCategoryMode.newName}
              </h3>
            </Tooltip>
          )}

          <div className="h-fit flex gap-1">
            {editNameCategoryMode.active && (
              <Tooltip title={`${t("Save")}`}>
                <IconButton
                  onClick={handleEditCategoryNameApi}
                  className="text-green-700"
                >
                  {isEditingCategoryName ? (
                    <CircularProgress size={16} />
                  ) : (
                    <CheckRoundedIcon className={`fill-green-700`} />
                  )}
                </IconButton>
              </Tooltip>
            )}
            {selectedCategory.isDefault ? (
              <Chip
                style={{
                  color: primaryColor,
                  borderColor: primaryColor,
                }}
                variant="outlined"
                label="Default"
                size="small"
                icon={<StarsRoundedIcon color={primaryColor} />}
              />
            ) : (
              <>
                <Tooltip
                  title={`${
                    editNameCategoryMode.active
                      ? t("Cancel")
                      : t("Edit") + " " + t("Name").toLowerCase()
                  }`}
                >
                  <IconButton
                    onClick={handleEditCategoryNameMode}
                    className="text-blue-900"
                  >
                    {editNameCategoryMode.active ? (
                      <CloseIcon className={`fill-blue-900`} />
                    ) : (
                      <EditIcon className={`fill-blue-900`} />
                    )}
                  </IconButton>
                </Tooltip>
                <Tooltip
                  title={`${t("Delete")} ${t("Category").toLowerCase()}`}
                >
                  <IconButton
                    onClick={() => setShowDeleteCategoryDialog(true)}
                    className="text-red-500"
                  >
                    <DeleteOutlineIcon className={`fill-red-500`} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </div>
        </div>

        {editNameCategoryMode.active ? null : (
          <div className="flex justify-end">
            <CoreTabBar
              tab={TABS_CATEGORY_PROPERTIES}
              setSelectedTab={setSelectedTab}
            />
          </div>
        )}
      </div>
      <Divider />
      {header(selectedTab)}

      <div className="w-full flex flex-col">
        <div
          style={{
            border: "1px solid #0000001f",
            height: "45vh",
          }}
          className="w-full rounded-md overflow-auto"
        >
          {isDataLoading && (
            <div className="p-4">
              <SkeletonsHorizontalLine height={50} length={25} />
            </div>
          )}
          {categoryToChange[selectedTab]?.map((keywordOrQueryObject, index) => (
            <div key={index}>
              <ListItem
                key={keywordOrQueryObject[selectedTab]}
                className="flex gap-4"
              >
                <TextField
                  name={selectedTab === "keywords" ? "keyword" : "query"}
                  className={`text-black font-bold ${
                    selectedTab === "keywords" ? "w-2/3" : "w-3/6"
                  } ${
                    selectedTab === "queries" &&
                    categoryToChange["queries"][index].freeQuery &&
                    "hidden"
                  }`}
                  value={
                    keywordOrQueryObject[
                      selectedTab === "keywords" ? "keyword" : "query"
                    ]
                  }
                  onChange={(e) => handleChangeInput(e, index)}
                />
                <>
                  <TextField
                    multiline
                    maxRows={3}
                    name={selectedTab === "keywords" ? "weight" : "description"}
                    type={selectedTab === "keywords" ? "number" : "string"}
                    className={`text-center 
                      ${selectedTab === "keywords" ? "w-1/6" : "w-2/6"} 
                      ${
                        selectedTab === "queries" &&
                        categoryToChange["queries"][index].freeQuery &&
                        "w-full "
                      }
                    `}
                    error={
                      selectedTab === "queries" &&
                      categoryToChange["queries"][index].description.length >
                        maxCharacter
                    }
                    value={
                      keywordOrQueryObject[
                        selectedTab === "keywords" ? "weight" : "description"
                      ]
                    }
                    onChange={(e) => handleChangeInput(e, index)}
                  />
                </>

                {selectedTab === "queries" && (
                  <CoreSelectObjArr
                    size="lg"
                    className={`w-1/6 ${
                      categoryToChange["queries"][index].freeQuery && "hidden"
                    }`}
                    name="fieldType"
                    label={t("DataType")}
                    value={categoryToChange["queries"][index].fieldType}
                    items={dataTypeElements()}
                    onChange={(e) => handleChangeInput(e, index)}
                  />
                )}

                <div className="flex text-center w-1/6 justify-center">
                  {selectedTab === "queries" && (
                    <p>
                      <Tooltip title="Query libera">
                        <Checkbox
                          sx={{
                            "&.Mui-checked": {
                              color: "gold",
                            },
                            color: "lightgrey",
                          }}
                          icon={<AutoAwesomeOutlinedIcon />}
                          checkedIcon={<AutoAwesomeRoundedIcon />}
                          checked={
                            categoryToChange["queries"][index].freeQuery ||
                            categoryToChange["queries"][index].query ===
                              "Campo libero"
                          }
                          onChange={(e) => handleChangeInput(e, index)}
                          name="freeQuery"
                        />
                      </Tooltip>
                    </p>
                  )}
                  <p>
                    <Tooltip title={t("Delete")}>
                      <IconButton
                        className="w-10 h-10"
                        onClick={() => handleDeleteItem(index)}
                      >
                        <HighlightOffRoundedIcon
                          fontSize="small"
                          className="text-red-600"
                        />
                      </IconButton>
                    </Tooltip>
                  </p>
                  {selectedTab === "queries" &&
                    !categoryToChange["queries"][index].freeQuery && (
                      <p className="flex items-center">
                        <CoreMaxCharacter
                          maxCharacter={maxCharacter}
                          text={categoryToChange["queries"][index].description}
                        />
                      </p>
                    )}
                </div>
              </ListItem>
              <Divider />
            </div>
          ))}
          <ListItem>
            <TextField
              className="text-center w-1/3"
              value={newKeywordOrQuery}
              onChange={(e) => setNewKeywordOrQuery(e.target.value)}
              label={`${t("Add")} ${
                selectedTab === "keywords" ? t("keyword") : t("query")
              }`}
            />
            <CoreButtonHoverIcon
              className="m-1"
              icon={<AddCircleOutlineRoundedIcon fontSize="small" />}
              testo={t("Add")}
              onClick={handleAddNewCategoryOrQuery}
            />
          </ListItem>
        </div>

        <div
          style={{ height: "7.5vh" }}
          className="flex justify-center items-center gap-4 p-4 mt-4"
        >
          <CoreButtonHoverIcon
            variant="contained"
            className="m-1"
            icon={<CheckRoundedIcon fontSize="small" />}
            testo={t("Save")}
            onClick={handleSave}
            disabled={
              !isCategoryChanged || isSettingKeywords || isSettingQueries
            }
          />
        </div>
      </div>
      <CoreDialog
        open={showDeleteCategoryDialog}
        title={t("Delete") + " " + t("Category").toLowerCase()}
        content={`${t("CategoryDeletingConfirm")} ${
          editNameCategoryMode?.newName
        }`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleDeleteCategory}
        closeDialog={() => setShowDeleteCategoryDialog(false)}
        disabledButton={isRemovingCategory}
      />
    </div>
  );
};

export default CategoryDetail;
